/* eslint-disable max-classes-per-file */
import { defaults as _defaults } from 'lodash';
var CurrencySortBy;
(function (CurrencySortBy) {
    CurrencySortBy[CurrencySortBy["Name"] = 0] = "Name";
    CurrencySortBy[CurrencySortBy["Ordinal"] = 1] = "Ordinal";
    CurrencySortBy[CurrencySortBy["Suffix"] = 2] = "Suffix";
})(CurrencySortBy || (CurrencySortBy = {}));
class CurrencyType {
    PK;
    Name;
    Suffix;
    constructor(params) {
        _defaults(this, params);
    }
}
const defaultMoney = {
    CurrencyType: new CurrencyType(),
    Formatted: '',
    Value: 0
};
const defaultMoneyTotal = {
    Count: 0,
    CurrencyType: new CurrencyType(),
    Formatted: '',
    Value: 0
};
class Money {
    CurrencyType;
    Formatted;
    Value;
    constructor(params) {
        _defaults(this, params, defaultMoney);
    }
}
class MoneyTotal {
    Count;
    CurrencyType;
    Formatted;
    Value;
    constructor(params) {
        _defaults(this, params, defaultMoneyTotal);
    }
}
const defaultConvertedMoney = {
    Original: new Money(),
    Rate: 0,
    RateDate: '',
    IsConverted: false
};
class ConvertedMoney extends Money {
    Original;
    Rate;
    RateDate;
    IsConverted;
    constructor(params) {
        super(params);
        _defaults(this, params, defaultConvertedMoney);
    }
}
export { CurrencySortBy, CurrencyType, ConvertedMoney, Money, MoneyTotal };
